
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, PhoneCall, MessageSquare } from "lucide-react";

export default function Help() {
  const faqs = [
    {
      question: "How do I find a charging station?",
      answer: "You can find charging stations by using our interactive map on the homepage. Enter your location or browse the map to find available chargers near you. You can filter by charger type, availability, and other features."
    },
    {
      question: "How do I book a charging session?",
      answer: "To book a charging session, select a station and click 'Book Now'. Choose your preferred time slot, enter your vehicle details, and complete the payment process. You'll receive a confirmation email with your booking details."
    },
    {
      question: "What if I need to cancel my booking?",
      answer: "You can cancel your booking up to 1 hour before your scheduled time through your account dashboard. Navigate to 'My Bookings' and select the booking you wish to cancel. Refunds are processed according to our cancellation policy."
    },
    {
      question: "How do I become a charging station host?",
      answer: "To become a host, click on 'Host Your Charger' in the navigation menu. You'll need to provide details about your charging equipment, location, and availability. Our team will review your application and guide you through the verification process."
    },
    {
      question: "What payment methods are accepted?",
      answer: "We accept all major credit cards, debit cards, and digital payment methods including Apple Pay and Google Pay. Payment is secured and processed at the time of booking."
    }
  ];

  return (
    <div className="container max-w-4xl py-8 px-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Help Center</CardTitle>
        </CardHeader>
        <CardContent className="space-y-8">
          {/* Contact Methods */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Card>
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center space-y-2">
                  <Mail className="h-8 w-8 text-primary" />
                  <h3 className="font-semibold">Email Support</h3>
                  <p className="text-sm text-muted-foreground">support@chargeshare.com</p>
                </div>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center space-y-2">
                  <PhoneCall className="h-8 w-8 text-primary" />
                  <h3 className="font-semibold">Phone Support</h3>
                  <p className="text-sm text-muted-foreground">1-800-CHARGE</p>
                </div>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center space-y-2">
                  <MessageSquare className="h-8 w-8 text-primary" />
                  <h3 className="font-semibold">Live Chat</h3>
                  <p className="text-sm text-muted-foreground">Available 24/7</p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* FAQs */}
          <div>
            <h2 className="text-xl font-semibold mb-4">Frequently Asked Questions</h2>
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger>{faq.question}</AccordionTrigger>
                  <AccordionContent>{faq.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
